"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
var Google = function Google(props) {
  var _a = props,
    className = _a.className,
    _a$size = _a.size,
    size = _a$size === void 0 ? IconSize.Medium : _a$size,
    _a$color = _a.color,
    color = _a$color === void 0 ? "inherit" : _a$color,
    rest = __objRest(_a, ["className", "size", "color"]);
  var iconClass = classNames(styles.icon({
    size: size,
    color: color
  }), "kl-icon", "kl-icon--".concat(size), className);
  return React.createElement("svg", __spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: iconClass
  }, rest), /* @__PURE__ */React.createElement("path", {
    fill: "#4285F4",
    d: "M22.038 12.235c0-.876-.07-1.516-.223-2.18h-9.918v3.958h5.822c-.118.984-.752 2.465-2.16 3.46l-.02.133 3.136 2.453.218.022c1.994-1.861 3.145-4.598 3.145-7.846Z"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "#34A853",
    d: "M11.897 22.664c2.852 0 5.246-.948 6.995-2.583l-3.333-2.608c-.892.628-2.09 1.067-3.662 1.067-2.794 0-5.164-1.86-6.01-4.432l-.124.01-3.26 2.549-.043.12c1.737 3.483 5.305 5.877 9.437 5.877Z"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "#FBBC05",
    d: "M5.887 14.108a6.623 6.623 0 0 1-.352-2.11c0-.734.129-1.445.34-2.109l-.005-.141-3.302-2.589-.108.052a10.76 10.76 0 0 0-1.127 4.787c0 1.719.411 3.343 1.127 4.788l3.427-2.678Z"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "#EB4335",
    d: "M11.897 5.457c1.983 0 3.322.865 4.084 1.588l2.982-2.939c-1.832-1.718-4.214-2.773-7.066-2.773-4.132 0-7.7 2.394-9.437 5.878L5.875 9.89c.858-2.571 3.228-4.432 6.022-4.432Z"
  }));
};
export default Google;